import { V1GetEquitiesSubscriptionVoluntaryEventsRequest } from '@genial/services/dist/apis';
import { EquityEnumsSubscriptionPeriodEnum } from '@genial/services/dist/models';

import { FilterModalTypes } from '../../components/FilterModal';
import { SectionTypes } from '../../components/FilterModal/filters/Section';

export const screenName = 'subscription';

export const defaultSubscriptionFilterType = 'Month' as EquityEnumsSubscriptionPeriodEnum;
export const otherSubscriptionFilterType = 'Other' as EquityEnumsSubscriptionPeriodEnum;

const subscriptionFilterOptions = [
  { label: 'Mensal', value: 'Month' as EquityEnumsSubscriptionPeriodEnum },
  { label: 'Últimos 3 meses', value: 'Quarter' as EquityEnumsSubscriptionPeriodEnum },
  { label: 'Outro', value: 'Other' as EquityEnumsSubscriptionPeriodEnum },
];

export const subscriptionRadioItemsSelect = {
  title: { default: 'Período:', modal: 'Período' },
  items: subscriptionFilterOptions,
};

export const subscriptionFilterTypeFieldName = 'filterType';
export const subscriptionDateRangeFieldName = 'commonDateRange';

export const subscriptionAvailableFilters: FilterModalTypes.FilterType[] = [
  {
    type: 'section',
    title: 'Período',
    fieldName: subscriptionFilterTypeFieldName,
    optionsColumns: 1,
    onlyOneSelection: true,
    options: subscriptionFilterOptions,
  },
  {
    type: 'dateRange',
    fieldName: subscriptionDateRangeFieldName,
    title: '',
    placeholder: 'Selecione',
    showOnlyIf: (selectedFilters) => {
      const typePeriodSelected = selectedFilters.find(
        (filter) => filter.fieldName === 'filterType'
      );
      return (typePeriodSelected?.filter as SectionTypes.SelectionProps)?.includes('Other');
    },
  },
];

export const initialFilterTypedOption = subscriptionRadioItemsSelect.items[0]
  .value as EquityEnumsSubscriptionPeriodEnum;

export const defaultSubscriptionListParams = {
  filterType: initialFilterTypedOption as EquityEnumsSubscriptionPeriodEnum,
} as Partial<V1GetEquitiesSubscriptionVoluntaryEventsRequest>;
